// extracted by mini-css-extract-plugin
export default {"root":"VideoSearch_root__zuPaD","body":"VideoSearch_body__pJSwm","noContent":"VideoSearch_noContent__rmv5-"};